module.exports = __webpack_public_path__ + "img/26.c7e148ba.jpg";